import { useUtils } from '../../../../../UtilsProvider';

export const useFullBannerImgSrc = (bannerImgSrc?: string): string => {
  const {
    media: { getMediaUrl },
  } = useUtils();

  if (!bannerImgSrc) {
    return '';
  }

  return getMediaUrl(bannerImgSrc);
};
